/* eslint camelcase: 0 */
import { toPriceProps } from './price'
import { toAgencyProps } from './agency'
import { toAreaProps } from './area'
import { toDivisionProps } from './division'
import { toFileProps } from './file'
import { Hospital, HospitalRequest, SubmissionDoc } from '@/infrastructure/network/Monitaro/schema/models'
import { IHospitalProps, IHospitalSubmissionDocProps, EmptyHospitalPropsFactory } from '@/entities/Hospital'
import { hasHospitalSubmissionDocUpload, shouldDeleteHospitalSubmissionDoc } from '@/utils/hospitalSubmissionDoc'

export const toHospitalProps = (props: Hospital | null | undefined): IHospitalProps => {
  if (!props) {
    return EmptyHospitalPropsFactory()
  }

  const {
    id,
    price,
    price_id,
    agencies,
    areas,
    divisions,
    submission_doc,
    name,
    kana,
    chargeable,
    approved,
    activation,
    term,
    rocotime,
    agency,
    properties,
    flags,
    doctors_count,
    users_count,
    type,
    status,
    joined_at,
    started_at,
    created_at,
    updated_at,
    leaved_at,
    payment_status
  } = props

  return EmptyHospitalPropsFactory({
    id,
    price: toPriceProps(price),
    priceId: price_id,
    agencies: agencies?.map(toAgencyProps),
    areas: areas?.map(toAreaProps),
    divisions: divisions?.map(toDivisionProps),
    submissionDoc: toHospitalSubmissionDocProps(submission_doc),
    keeps: submission_doc?.file ? [toFileProps(submission_doc.file)] : null,
    name,
    kana,
    chargeable,
    approved,
    activation,
    term,
    rocotime,
    agency,
    properties,
    flags,
    doctorsCount: doctors_count,
    usersCount: users_count,
    type,
    status,
    joinedAt: joined_at,
    startedAt: started_at,
    createdAt: created_at,
    updatedAt: updated_at,
    leavedAt: leaved_at,
    paymentStatus: payment_status
  })
}

export const toHospitalSubmissionDocProps = (props: SubmissionDoc | null | undefined): IHospitalSubmissionDocProps | null => {
  if (!props) {
    return null
  }

  const { id, charge_id, media_id, file, editable, submitted_at } = props

  return {
    id,
    chargeId: charge_id,
    mediaId: media_id,
    file: file ? toFileProps(file) : null,
    editable,
    submittedAt: submitted_at
  }
}

export const toHospitalRequest = (props: IHospitalProps): HospitalRequest => {
  const { term, areas, data } = props

  return {
    areas: areas?.map((prop) => prop.id!) || [],
    ...(term ? { term } : {}),
    ...(hasHospitalSubmissionDocUpload(props) ? { file: data } : {}),
    ...(shouldDeleteHospitalSubmissionDoc(props) ? { delete_submission_doc: true } : {})
  }
}
